import Vue from "vue"

Vue.filter("formatLocale", function (value) {
    if (!value) return ''
    return Number(value).toLocaleString(); 
})